import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import "./translations/i18n";
import reportWebVitals from "./reportWebVitals";
import disableConsoleOutput from "./disableConsoleLog";
import App from "./App";

import "./styles/index.scss";

const {
  REACT_APP_ENV,
  REACT_APP_VERSION,
  PUBLIC_URL,
  REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID,
} = process.env;

// Inject GTM so container ID comes from env (not possible in public/index.html)
if (REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== "dataLayer" ? `&l=${l}` : "";
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
    f.parentNode.insertBefore(j, f);
  }(window, document, "script", "dataLayer", REACT_APP_GOOGLE_TAG_MANAGER_CONTAINER_ID));
}

// Disable some console methods
if (REACT_APP_ENV === "production") {
  // whitelist: info, warn, error
  disableConsoleOutput(["log", "debug", "time", "timeEnd"]);
}

console.info(`[boost] REACT_APP_VERSION = "${REACT_APP_VERSION}"`);
console.info(`[boost] PUBLIC_URL = "${PUBLIC_URL}"`);
console.info(`[boost] REACT_APP_ENV = "${REACT_APP_ENV}"`);

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
